import {ErrorType} from "./error-type"
import FieldProto from "../../fields3/proto/field-proto"
import ErrorProto from "./error"

type Params = {
    message     : string
    errorType?  : ErrorType
}

export default class ErrorFieldCustom extends ErrorProto {

    public field            : FieldProto
    public customMessage    : string        // may contain placeholder {0} for field label

    constructor(field:FieldProto, params: Params) {
        super()

        this.type           = _.get(params, 'errorType', ErrorType.FieldIncorrectValue)
        this.field          = field
        this.customMessage  = params.message
    }

    get message() {
        return this.customMessage.f(this.field.label)
    }
}